export default {
      id: "weather__pressure-usage",
      viewBox: "0 0 530 530",
      url: __webpack_public_path__ + "img/icons.svg#weather__pressure",
      toString: function () {
        return this.url;
      }
    }